/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".titleField_265b10af{display:inline-block}\n"}]);
export const titleField = "titleField_265b10af";